import React from "react";
import { Sun, Moon } from "lucide-react";

const Header = ({ isDark, setIsDark }) => {

  return (
    <header className="flex-shrink-0 h-12 sticky top-0 z-50">
      <div className="h-full px-4 flex items-center justify-end">
        {/* Right Section - Theme Toggle Only */}
        <button
          onClick={() => setIsDark(!isDark)}
          className="p-2 rounded-lg hover:bg-bg-200/50 text-text-400 hover:text-text-200 transition-colors"
          title="Toggle theme"
        >
          {isDark ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
        </button>
      </div>
    </header>
  );
};

export default Header;
